import gql from "graphql-tag";
import { Distributor } from "../../api/schema";

export interface DistributorListResponse {
  distributors: Array<Distributor>;
}

export interface DeleteDistributorResponse {
  deleteDistributor: boolean;
}

export interface UpdateDistributorResponse {
  updateDistributor: { id: number };
}

export interface CreateDistributorResponse {
  createDistributor: { id: number };
}

export const DistributorListQuery = gql`
  query distributors {
    distributors {
      id
      name
      short_name
      search_url
    }
  }
`;

export const UpdateDistributorMutation = gql`
  mutation updateDistributor($values: UpdateDistributorInput!) {
    updateDistributor(values: $values) {
      id
    }
  }
`;

export const CreateDistributorMutation = gql`
  mutation createDistributor($values: CreateDistributorInput!) {
    createDistributor(values: $values) {
      id
    }
  }
`;

export const DeleteDistributorMutation = gql`
  mutation deleteDistributor($id: ID!) {
    deleteDistributor(id: $id)
  }
`;
